import {NgModule} from '@angular/core';
import {FilesUploaderComponent} from './files-uploader/files-uploader.component';
import {CommonModule} from '@angular/common';
import {FilesUploaderService} from './files-uploader.service';
import {LayoutModule} from '@layoutComponents/layout.module';
import {ModalModule} from '../modal/modal.module';
import {ImageCropperModalComponent} from './image-cropper-modal/image-cropper-modal.component';
import {SingleFileUploaderComponent} from '@components/files-uploader/single-file-uploader/single-file-uploader.component';
import {PipesModule} from '@pipes/pipes.module';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {IconsModule} from '@lab365/icons';


@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        ModalModule,
        PipesModule,
        DirectivesModule,
        IconsModule,
    ],
    exports: [
        FilesUploaderComponent,
        SingleFileUploaderComponent,
    ],
    declarations: [
        FilesUploaderComponent,
        ImageCropperModalComponent,
        SingleFileUploaderComponent,
    ],
    providers: [
        FilesUploaderService
    ],
})
export class FilesUploaderModule {
}
